var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronYellowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "9px",
    viewBox: "0 0 6 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Virtuaalpere---Entry",
    transform: "translate(-700.000000, -949.000000)",
    stroke: "#FFCD00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(420.000000, 929.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    transform: "translate(251.500000, 8.500000) rotate(-90.000000) translate(-251.500000, -8.500000) ",
    points: "248.5 7 251.5 10 254.5 7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronYellowRight);
export default __webpack_public_path__ + "static/media/Icon_Chevron_Yellow-Right.771c3bf0f17c80925f0a07b4904070a2.svg";
export { ForwardRef as ReactComponent };